import { API_ORIGIN, SITE_ORIGIN } from '../services/config';

function normalizeAbsolute(url) {
  return /^https?:\/\//i.test(url);
}

export function resolveAssetUrl(value) {
  if (!value) return '';

  const normalized = String(value).trim().replace(/\\/g, '/');
  if (!normalized) return '';

  if (normalizeAbsolute(normalized) || normalized.startsWith('data:') || normalized.startsWith('blob:')) {
    return normalized;
  }

  if (normalized.startsWith('/media/') || normalized.startsWith('media/')) {
    const path = normalized.startsWith('/') ? normalized : `/${normalized}`;
    return `${API_ORIGIN}${path}`;
  }

  if (normalized.startsWith('/uploads/') || normalized.startsWith('uploads/')) {
    const path = normalized.startsWith('/') ? normalized : `/${normalized}`;
    return `${SITE_ORIGIN || API_ORIGIN}${path}`;
  }

  if (normalized.startsWith('/images/') || normalized.startsWith('images/')) {
    const path = normalized.startsWith('/') ? normalized : `/${normalized}`;
    return `${SITE_ORIGIN || API_ORIGIN}${path}`;
  }

  if (normalized.startsWith('/')) {
    return `${SITE_ORIGIN || API_ORIGIN}${normalized}`;
  }

  if (SITE_ORIGIN) {
    return `${SITE_ORIGIN}/images/${normalized}`;
  }

  return normalized;
}
